import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import ProgressBar from "./ProgressBar";

function SkillColumn({ title, items }) {
  return (
    <div className="flex flex-col items-center text-center">
      <h3 className="text-xs sm:text-sm tracking-widest uppercase text-[#D4AF6A] mb-4 sm:mb-5">
        {title}
      </h3>
      <div className="flex flex-wrap justify-center gap-2 sm:gap-2.5">
        {items.map((item, index) => (
          <span
            key={index}
            className="hover-glow flex items-center gap-2 text-xs sm:text-sm text-[#D9D2C2] border border-white/10 bg-white/[0.03] px-3 sm:px-3.5 py-1.5 sm:py-2 rounded-full"
          >
            <FontAwesomeIcon
              className="text-[#D4AF6A] text-[6px]"
              icon={faCircle}
            />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function Skills({
  databases,
  frameworks,
  programming_language,
  progress_bars,
}) {
  return (
    <section
      id="skills"
      className="relative bg-[#081712] text-[#F1E9D8] px-5 sm:px-6 md:px-10 py-20 sm:py-24 md:py-32 grain"
    >
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 sm:w-[28rem] sm:h-[28rem] rounded-full bg-[#26502F] opacity-40 blur-[100px] sm:blur-[140px]" />

      <div className="max-w-4xl mx-auto relative">
        <div className="flex items-center justify-center gap-3 sm:gap-4 mb-12 sm:mb-16">
          <span className="text-xs sm:text-sm text-[#D4AF6A]">04</span>
          <span className="w-6 sm:w-10 h-px bg-[#D4AF6A]/40" />
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-light">
            Skills
          </h2>
          <span className="w-6 sm:w-10 h-px bg-[#D4AF6A]/40" />
          <span className="text-xs sm:text-sm text-[#D4AF6A]">04</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 md:gap-12 mb-14 sm:mb-20">
          <SkillColumn title="Languages" items={programming_language} />
          <SkillColumn title="Databases" items={databases} />
          <SkillColumn title="Technologies" items={frameworks} />
        </div>

        <div className="max-w-xl mx-auto">
          <h3 className="text-xs sm:text-sm tracking-widest uppercase text-[#D4AF6A] mb-6 sm:mb-8 text-center">
            Frameworks
          </h3>
          {progress_bars.map((prog, index) => (
            <ProgressBar
              key={index}
              title={prog.title}
              percentage={prog.percentage}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
